<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1> Pithora One-Day Rapid Chess Tournament 2025</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section-lg">
  <div class="container">
    <div class="sec-title">
      <h2><span>GH Raisoni Memorial One-Day Rapid Chess Tournament Concludes Grandly at Pithora Ujala Palace</span></h2>
    </div>

<h5>Pithora:</h5>
 <p>The GH Raisoni Memorial One-Day Rapid Chess Tournament concluded gracefully at Pithora Ujala Palace, creating an atmosphere of excitement and sportsmanship.</p>
<p>The event was organized with the special support of the GH Raisoni Sports and Cultural Foundation and the Kalpana Prakash Welfare Foundation.</p>

<h6>Prize Distribution & Closing Ceremony</h6>

<p>The Chief Guest of the closing ceremony was Shri Swapnil Tiwari (MLA Representative and District President, Shramjivi Patrakar Sangh, Mahasamund).</p>
<p>The event was chaired by Dr. D. N. Sahu, President of the Mahasamund District Chess Association.</p>

<h6>Distinguished Guests:</h6>
<ul class="list-style list-style1 mb-3">
<li>Shri Vijay Naik – District Vice-President, BJP Morcha</li>

<li>Shri Vijay Raj Patel – Mandal President, Yuva Morcha, BJP</li>

<li>Shri Biju Patnaik – Treasurer, District Chess Association</li>
</ul>
<p>Chief Guest Swapnil Tiwari appreciated the efforts of Tournament Director Hemant Khute for taking chess beyond the block and district level and earning a national-level identity.</p>
<p>Presiding over the event, Dr. D. N. Sahu emphasized the association’s commitment to promoting chess and providing larger platforms for budding players.</p>

<h6>Special Felicitation</h6>

<p>Chief Arbiter Rocky Dewangan, recently honored with the title of International Arbiter by FIDE (World Chess Federation), was felicitated with a shawl, coconut, and memento for his outstanding achievement.</p>

<h6>Prize Details</h6>

<p>A total cash prize of ₹30,000 along with trophies and mementos was distributed among the winners.</p>

<h6>Open Category Winners:</h6>
<ul class="list-style list-style1 mb-3">
<li> Manish Thadani (Mahasamund) – ₹9,100 + Trophy</li>
<li> Priyanshu Patle (Mahasamund) – ₹7,100 + Trophy</li>
<li> Yug Vijay Sahu (Mahasamund) – ₹5,100 + Trophy</li>
<li> Akhilesh Kumar Kar (Basna) – ₹3,100 + Memento</li>
<li> Shyam Sundar Dubey (Pithora) – ₹1,100 + Memento</li>
<li> Ravindra Gwal (Basna) – ₹500</li>
<li> Rajesh Giri Goswami (Saraipali) – ₹500</li>
<li>Kesar Bhoy (Pithora) – ₹500</li>
<li> Vipin Kumar Sahu (Mahasamund) – ₹500</li>
<li> Komal Dhruvanshi (Bagbahara) – ₹500</li>
</ul>

<h6>Special Awards:</h6>
<ul class="list-style list-style1 mb-3">
<li>Best Female Player: Sanjeeta Sahu (Pithora) – ₹1,000</li>
<li>Youngest Player: Moksh Sharma (Mahasamund) – ₹500 + Trophy</li>
<li>Best Veteran: Dinesh Kumar Kar (Basna) – ₹500 + Trophy</li>
</ul>
<h6>Age-Group Winners:</h6>
<ul class="list-style list-style1 mb-3">
  <li>Under-11: Pranav Sahu (Basna) – 1st; Prakhar Mishra (Mahasamund) – 2nd</li>

  <li>Under-13: Aashi Satpathy (Saraipali) – 1st; Hoshika Patel (Pithora) – 2nd</li>

  <li>Under-15: Deepanshu Patle (Mahasamund) – 1st; Ishan Bhoy (Saraipali) – 2nd</li>
</ul>


<p>All trophies and awards were presented by the distinguished guests.</p>
  </div>
</section>
<section class="section-lg pt-0">
  <div class="container">
     <hr class="mb-5">
              <div class="sec-title mt-4 text-center">
                    <h2><span>Photo Gallery</span></h2>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <hr class="my-5">
                 <div class="sec-title mt-4 text-center">
                    <h2><span>Media Coverage</span></h2>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament25-7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
  </div>
</section>
